module.exports = __webpack_public_path__ + "static/media/brasao_SantuÃ_rio_CERTO-removebg-preview.045c60de.png";